module.exports = __webpack_public_path__ + "img/quanzi.105817b3.png";